import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import Day from "./pages/Day";
import Night from "./pages/Night";
import CoverFrame from "./pages/CoverFrame";
import { useEffect } from "react";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/night":
        title = "";
        metaDescription = "";
        break;
      case "/coverframe":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Day />} />
      <Route path="/night" element={<Night />} />
      <Route path="/coverframe" element={<CoverFrame />} />
    </Routes>
  );
}
export default App;
